export const environment = {
  production: true,
  
  apiUrl: "https://umyopd.site/api_umyocards/public/api/"
};


